import React from 'react';
import { Typography } from '@material-ui/core';
import { Control } from 'react-hook-form';

import TextComponent from 'components/forms-v2/Text.component';
import useInputStyles from './EventInput.styles';
import { editEventFormKeys } from '../types/FormTypes';

interface EventLocationProps {
  control: Control<any, any>;
}

const EventLocation: React.FC<EventLocationProps> = ({ control }) => {
  const baseClasses = useInputStyles();

  return (
    <div className={baseClasses.root}>
      <Typography variant="body1">Location</Typography>
      <TextComponent
        name={editEventFormKeys.location}
        control={control}
        rules={{
          required: { value: true, message: 'Enter location' },
        }}
        label="Location"
        helperText="Meeting Point or main location of the event"
        style={{ margin: '0' }}
      />
    </div>
  );
};

export default EventLocation;
